import React, { useState } from 'react';
import PropTypes from 'prop-types';

import StyledEventFilterTags from './eventFilterTags.style';
import CloseIcon from '../../icons/close.svg';
import Container from '../../layout/container/container';

const EventFilterTags = ({ tags, activeCategory, callback }) => {
  const [activeTag, setTag] = useState(activeCategory);

  const setActiveTag = e => {
    const clickedTag = e.target.dataset.tag;
    if (activeTag === clickedTag) {
      setTag('');
      callback(null);
    } else {
      setTag(clickedTag);
      callback(clickedTag);
    }
  };

  return (
    <Container large>
      <StyledEventFilterTags>
        {tags &&
          tags.map(tag => (
            <button
              className={`eventFilterTags__tag 
              ${activeTag === tag.id.toString() ? 'eventFilterTags__tag--active' : ''}`}
              key={tag.id}
              data-tag={tag.id}
              onClick={setActiveTag}
              tabIndex={0}
              type="button"
              onKeyDown={setActiveTag}
            >
              <span data-tag={tag.id}>
                {tag.title}{' '}
                {activeTag === tag.id.toString() && (
                  <CloseIcon
                    data-tag={tag.id}
                    className="eventFilterTag__close"
                    width={16}
                    height={16}
                  />
                )}
              </span>
            </button>
          ))}
      </StyledEventFilterTags>
    </Container>
  );
};

EventFilterTags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      slug: PropTypes.string
    })
  ),
  activeCategory: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired
};

export default EventFilterTags;
